<i class="fa {{ value ? 'fa-check-circle' : 'fa-ban' }}"></i>
